import './form-speed-service.scss'
// components
import Button from '../../../atoms/button/button'
import Input from '../../../atoms/input/input'
// icons
import { RabbitIcon, TurtleIcon } from '../../../atoms/icons'

const FormSpeedService = props => {
	const { value, action, sendData, buttonText } = props

	// functions
	const setColor = position => {
		if (position < 10) return '#FC2233'
		if (position < 20) return '#F6772A'
		return '#179552'
	}

	/**
	 * If the position is 5, 15, or 26, return 'big', otherwise return an empty string.
	 * @returns a string.
	 */
	const setBig = position => {
		if (position === 5 || position === 15 || position === 26) return 'big'
		return ''
	}

	/**
	 * This function takes a string, parses it to an integer, and then calls another function with the
	 * parsed integer.
	 */
	const setRealValue = async newValue => {
		const valueParsed = parseInt(newValue)
		action({ value: valueParsed, key: 'speedAnswer' })
	}

	return (
		<div className='m-form-speed-service'>
			<div className='m-form-speed-service__range'>
				<Input
					type='range'
					label=''
					value={value || 0}
					min={0}
					max={100}
					change={e => setRealValue(e.target.value)}
				/>
				<div className='m-form-speed-service__range__mark' data-testid='range-mark'>
					{Array.from(Array(30).keys()).map((_, index) => (
						<span
							key={index}
							className={`${setBig(index + 1)}`}
							style={{ backgroundColor: setColor(index + 1) }}
						/>
					))}
				</div>
				<div className='m-form-speed-service__range__icons'>
					<TurtleIcon color='#FF5555' data-testid='turtle-icon' />
					<RabbitIcon color='#189950' data-testid='rabbit-icon' />
				</div>
			</div>
			{buttonText && (
				<Button
					uppercase
					disabled={!value}
					classes='pink'
					title={buttonText}
					onClick={() => sendData()}
				/>
			)}
		</div>
	)
}

export default FormSpeedService
